import React, { useState } from 'react';
import { CSSObject } from '@emotion/react';
import { Box, IconButton } from '@mui/material';

import Icon from '@components/Icon';

import * as S from './styles';
import COLORS from '@styles/theme/colors';

interface Props {
  onEdit: () => void;
  onDelete: () => void;
  onShowInfo?: () => void;
  customStyles?: CSSObject;
  isShowMore?: boolean;
  isEdit?: boolean;
  isCopy?: boolean;
  onCopy: () => void;
}

const MoreActionsButton = ({ onEdit, onDelete, onShowInfo, customStyles, isShowMore, isEdit, isCopy, onCopy }: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const onMore = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={customStyles}>
      <S.ActionButtonsCell>
        <IconButton onClick={onMore}>
          <Icon icon='more' size={19} color='#000' />
        </IconButton>
      </S.ActionButtonsCell>


      <S.DropDownMenu anchorEl={anchorEl} open={open} onClose={onClose}>
        <S.MenuList>
          {isShowMore &&
            <S.MenuListItem
              onClick={() => {
                onClose();
                onShowInfo();
              }}
            >
              <S.MenuIconWrapper>
                <Icon icon='recruitment' size={12} color={COLORS.textSecondColorLight} />
              </S.MenuIconWrapper>
              <div>Show More</div>
            </S.MenuListItem>
          }
          {isEdit &&
            <S.MenuListItem
              onClick={() => {
                onClose();
                onEdit();
              }}
            >
              <S.MenuIconWrapper>
                <Icon icon='pencil' size={12} color={COLORS.textSecondColorLight} />
              </S.MenuIconWrapper>
              <div>Edit</div>
            </S.MenuListItem>
          }

          {isCopy &&
            <S.MenuListItem
              onClick={() => {
                onClose();
                onCopy();
              }}
            >
              <S.MenuIconWrapper>
                <Icon icon='file-copy' size={12} color={COLORS.textSecondColorLight} />
              </S.MenuIconWrapper>
              <div>Сlone</div>
            </S.MenuListItem>
          }
          <S.MenuListItem
            onClick={() => {
              onClose();
              onDelete();
            }}
          >
            <S.MenuIconWrapper>
              <Icon icon='trash' size={12} color={COLORS.textSecondColorLight} />
            </S.MenuIconWrapper>
            <div>Delete</div>
          </S.MenuListItem>
        </S.MenuList>
      </S.DropDownMenu>
    </Box>
  );
};

export default MoreActionsButton;
